import { RouteConfig } from 'vue-router';
import useI18n from '@/mixins/useI18n';
import { isPrerenderBuild, shouldUsePublicLandingpage } from '@/utils/publicSite';
import LandingpageSwitch from '@/views/public/landingpage/LandingpageSwitch.vue';
import LandingpageFreelancer from '@/views/public/landingpage/LandingpageFreelancer.vue';
import LandingpageCustomer from '@/views/public/landingpage/LandingpageCustomer.vue';

const { t } = useI18n();
const usePublicLandingpage = shouldUsePublicLandingpage();

const routes: RouteConfig[] = [
  {
    name: 'Landingpage',
    path: '/landingpage',
    component: LandingpageSwitch,
    beforeEnter(to, from, next) {
      // Don't redirect during prerendering - we need to render this route
      if (usePublicLandingpage && !isPrerenderBuild()) {
        next({ name: 'index', query: to.query, hash: to.hash });
        return;
      }
      next();
    },
    meta: {
      layout: 'landingpage',
      title: t('landingpage.title_switch'),
      description: t('landingpage.meta_switch'),
    }
  }, {
    name: 'landingpage-freelancer',
    path: '/freelancer',
    component: LandingpageFreelancer,
    meta: {
      layout: 'landingpage',
      title: t('landingpage.title_freelancer'),
      description: t('landingpage.meta_freelancer'),
    }
  }, {
    name: 'landingpage-customer',
    path: '/customer',
    component: LandingpageCustomer,
    meta: {
      layout: 'landingpage',
      title: t('landingpage.title_customer'),
      description: t('landingpage.meta_customer'),
    }
  }
];

export default routes;
